import type { ReactNode } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate } from "src/router";

// biome-ignore lint/style/useComponentExportOnlyModules: tiny flag hook co-located with its route gate; Fast Refresh loss is irrelevant here
export function useLaunchesEnabled(): boolean {
  const { adStudioIntelligenceLaunches } = useFlags();
  return import.meta.env.DEV || Boolean(adStudioIntelligenceLaunches);
}

export function LaunchesFeatureRoute({
  children,
  redirect,
}: {
  children: ReactNode;
  redirect: string;
}) {
  return useLaunchesEnabled() ? (
    <>{children}</>
  ) : (
    <Navigate to={redirect} replace />
  );
}
